/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Box, Grid, Link, Button, Stack, useTheme, alpha, } from '@mui/material';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import { withWidth } from '@material-ui/core';
import LockIcon from '@mui/icons-material/Lock';
import { IParlayOutcome, IShopOutcome } from '../pick6/store/types';

const BetRow = ({
  parlayOutcome,
  isUserPremium,
  type,
  onClick,
  contrastCardBackground = false,
  dataPoints,
}: {
  parlayOutcome: IParlayOutcome | IShopOutcome;
  isUserPremium: boolean;
  type: 'Add' | 'Remove' | 'Swap';
  dataPoints: {
    header: string,
    data: string | number | React.ReactNode,
    highlight?: number,
  }[];
  onClick: (o: IParlayOutcome | IShopOutcome) => void;
  contrastCardBackground: boolean;
}) => {
  const theme = useTheme();

  const {
    eventLabel,
    leagueCode,
    line,
    label,
    offerName,
    participantName,
    participantLabel,
    oddsAmerican,
    deepLinkUrl,
    playerParticipantHeadShot,
    outcomeId
  } = parlayOutcome;

  const endIcon = () => {
    if (!isUserPremium) {
      return <HttpsOutlinedIcon fontSize="small" />;
    }
    switch (type) {
      case 'Remove': {
        return <RemoveCircleIcon>Remove</RemoveCircleIcon>;
      }
      case 'Swap': {
        return <SwapHorizontalCircleIcon>Swap</SwapHorizontalCircleIcon>;
      }
      default: {
        return <AddCircleIcon>Add</AddCircleIcon>;
      }
    }
  };

  const colorDictionary = {
    'Add': {
      border: `0.5px solid #00954D`,
      color: '#00954D',
      backgroundColor: alpha('#00954D', .1),
      '&:hover': {
        border: `0.5px solid #00954D`,
      }
    },
    'Swap': {
      border: `0.5px solid #4395FF`,
      color: '#4395FF',
      backgroundColor: alpha('#4395FF', .1),
      '&:hover': {
        border: `0.5px solid #4395FF`,
      }
    },
    'Remove': {
      border: `0.5px solid #EE707E`,
      color: '#EE707E',
      backgroundColor: alpha('#EE707E', .1),
      '&:hover': {
        border: `0.5px solid #EE707E`,
      },
    },
  };

  return (
    <Grid sx={{
      border: `1px solid #1C1C1C`,
      borderRadius: '12px',
      boxShadow: theme.shadows[2],
      overflow: 'hidden',
      width: '100%',
      backgroundColor: '#252525',
      color: 'white',
      '&:not(:last-child)': {
        marginBottom: 24,
      },
      ...(contrastCardBackground && { backgroundColor: '#1C1C1C' })
    }}>
      <Grid container xs={12} justifyContent='space-between'>
        <Grid container xs={9} alignItems='center' padding='8px' flexWrap='nowrap'>
          <Box width="25px" height="25px" mr='8px' sx={{ backgroundColor: alpha(theme.palette.common.white, .15), borderRadius: '20px' }}>
            <img src={playerParticipantHeadShot} alt={participantName} style={{ height: '100%', width: '100%', borderRadius: '20px' }} />
          </Box>
          <Stack direction='column' fontSize={{ xs: '12px', md: '16px' }} width='100%' overflow='hidden'>
            <Box fontWeight={500}
              color={alpha(theme.palette.common.white, .87)}
              fontSize="12px"
              textOverflow='ellipsis'
              overflow='hidden'
              sx={{ 'text-wrap': 'nowrap' }}
            >
              {participantLabel}
            </Box>
            <Box fontWeight={700} textOverflow='ellipsis' overflow='hidden' color='white' fontSize={{ xs: '12px', md: '16px' }}>{label} {line} {offerName}</Box>
            <Stack direction='row' fontSize='10px' alignItems='center' color='white'>
              <Box sx={{
                borderRadius: '10px',
                backgroundColor: '#101010',
                padding: '0 4px',
                fontWeight: 700,
                marginRight: '2px'
              }}>
                {leagueCode}
              </Box>
              {eventLabel}
            </Stack>
          </Stack>
        </Grid>
        <Grid container xs={3} justifyContent='flex-end'>
          <Stack direction='column' paddingTop="8px">
            <Stack direction='row'>
              <Link href={deepLinkUrl} sx={{
                borderRadius: '6px',
                padding: '6px 8px',
                marginRight: '8px',
                border: `0.5px solid ${'#4395ff'}`,
                background: alpha('#4395ff', .1),
                textDecoration: 'none !important',
                height: '24px',
                whiteSpace: 'nowrap',
                textTransform: 'uppercase',
                fontSize: { xs: '10px', md: '14px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>Bet Now</Link>
            </Stack>
            <Stack direction='row' justifyContent='flex-end' alignItems={'center'} gap={1} fontSize='16px' fontWeight={700} marginRight="10px" paddingTop={'8px'}>
              <Box sx={{ paddingRight: '20px' }}>{oddsAmerican}</Box>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      <Grid container xs={12} justifyContent='space-between' sx={{ padding: 0 }}>
        <Grid container xs={8} sx={{ padding: '0px', flexWrap: 'nowrap' }}>
          {
            dataPoints?.map((x, index) => {
              if (x.highlight) {
                return (
                  <Stack direction='column' justifyContent='center' alignItems='center' padding="6px 10px" sx={{ backgroundColor: alpha("#009F52", x.highlight || 1), ...(index !== 0 && { borderTopRightRadius: '12px' }) }} key={outcomeId}>
                    <Box fontSize='8px' fontWeight={500}>{x.header}</Box>
                    <Box fontSize='14px' fontWeight={700}>{isUserPremium ? (x.data || '-') : <LockIcon fontSize='small' sx={{ fontSize: '20px', pt: '4px' }} />}</Box>
                  </Stack>
                )
              } else {
                return (
                  <Stack direction='column' justifyContent='center' alignItems='center' padding="6px 10px" key={outcomeId}>
                    <Box fontSize='8px' fontWeight={500} whiteSpace='nowrap'>{x.header}</Box>
                    <Box fontSize='12px' fontWeight={700} whiteSpace='nowrap'>{isUserPremium ? (x.data || '-') : <LockIcon fontSize='small' sx={{ fontSize: '20px', pt: '4px' }} />}</Box>
                  </Stack>
                )
              }


            })
          }
        </Grid>
        <Grid container xs={4} justifyContent='flex-end' alignItems='flex-end' sx={{
          padding: '8px',
          '& .MuiButton-outlinedPrimary': {
            borderRadius: '6px',
            padding: '6px 8px',
            fontSize: '12px',
            width: '84px',
            height: '28px',
            '& svg': {
              width: 16,
              height: 16
            },
            ...colorDictionary[type]
          },
        }}>
          <Button variant="outlined" endIcon={endIcon()} onClick={() => onClick(parlayOutcome)}>
            {type}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withWidth()(BetRow);
